import { Component, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import * as _ from 'lodash';
import * as debug from 'debug';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';
import { ToolsProvider } from '../../providers/tools/tools';

interface Tag {
  type: string;
  src: string;
  attributes: [{ key: string; value: string }];
}

@Component({
  selector: 'ad-tags',
  templateUrl: 'ad-tags.html',
})
export class AdTags implements AfterViewInit {

  @ViewChild('content') content: ElementRef;
  @Input() adLocationId: string;
  @Input() tags: Tag[];
  log = debug('app:AdTags');
  observer: IntersectionObserver;

  constructor(
    public crudApi: CrudApiProvider,
    public tools: ToolsProvider
  ) {}

  ngAfterViewInit() {
    this.initObserver();
  }

  initObserver() {
    if (!this.content?.nativeElement) return;

    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.log('Element is in view', this.content.nativeElement);
            this.loadAdTags();
            observer.unobserve(entry.target); // Stop observing after loading
          }
        });
      },
      { threshold: 0.5 } // 50% of the element must be visible
    );

    this.observer.observe(this.content.nativeElement);
  }

  async loadAdTags() {
    for (const tag of this.tags) {
      if (tag.type === 'script') {
        await this.addScript(tag);
      } else if (tag.type === 'image') {
        await this.addImageTag(tag);
      }
    }
  }


  onClick() {
    _.each(this.tags, (t: Tag) => {
      if (t.type === 'click') {
        const campaignId = _.get(t,'campaignId') ? `--${_.get(t, 'campaignId')}` : '';
        this.tools.logAnalyticsEvent(
          'trackCustom', 
          'ad-tags--click' + campaignId, 
          { 
            url: t.src, 
            campaignId,
            location: this.adLocationId
          }
        );
        this.log('click tag', t);
        this.tools.openExternalUrl(t.src, '_blank');
      }
    });
  }

  addScript(t: Tag) {
    return new Promise((resolve, reject) => {
      const s = document.createElement('script');
      const campaignId = _.get(t, 'campaignId') ? `--${_.get(t, 'campaignId')}` : '';
      this.tools.logAnalyticsEvent(
        'trackCustom', 
        'ad-tags--script' + campaignId, 
        { 
          url: t.src, 
          campaignId,
          location: this.adLocationId
        }
      );
      s.setAttribute('src', t.src);
      s.classList.add('tracking-tag');
      _.each(t.attributes, att => {
        s.setAttribute(att.key, att.value || att.key);
      });

      s.onload = resolve;
      s.onerror = reject;
      document.body.appendChild(s);
    });
  }

  addImageTag(t: Tag) {
    return new Promise((resolve, reject) => {
      if (!this.content?.nativeElement) return;
      
      const img = document.createElement('img');
      const campaignId = _.get(t, 'campaignId') ? `--${_.get(t, 'campaignId')}` : '';
      this.tools.logAnalyticsEvent(
        'trackCustom', 
        'ad-tags--image' + campaignId, 
        {
          url: t.src, 
          campaignId,
          location: this.adLocationId
        }
      );
      img.setAttribute('src', t.src);
      img.setAttribute('style', 'position: absolute;');

      try {
        _.each(t.attributes, att => {
          img.classList.add('tracking-tag');
          img.setAttribute(att.key, att.value);
        });
      } catch (e) {}

      img.addEventListener('load', resolve);
      img.addEventListener('error', reject);
      this.content.nativeElement.appendChild(img);
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/ad-tags/ad-tags.ts